import megatron from '@ibibo/megatron';

import {prepareGetOffersApiRequest} from './../utils/prepareGetOffersApiRequest';
import {AppState} from './../../../store';
import {ThunkAction, ThunkDispatch} from 'redux-thunk';
import {AnyAction} from 'redux';
import {
  updateOffersDataAction,
  toggleLoadingGetOffersAction,
  campaingDataAction,
  toggleLoadingCamapaignAction,
  updateCampaignHeadData,
} from './actions';
import {IOffersApi, ICampaignData} from './types';
import {prepareCampaignApiRequest} from '../utils/prepareDestinationsApiRequest';

export const bannerReveal = async () => {
  const url = `/hotels/road-block?key=1`;
  return await megatron({
    name: 'Banner Reveal',
    type: 'GET',
    url,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const fetchOffersDataThunk = (): ThunkAction<void, AppState, {}, AnyAction> => {
  return (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    dispatch(toggleLoadingGetOffersAction(true));
    const url = '/hotels/road-block?key=2';
    megatron({
      name: 'banner api cache data retreival',
      type: 'GET',
      url,
      credentials: 'omit',
    })
      .then(response => {
        // This will later be made dynamic through api response. Kept temporarily for any further short fix
        // /* Response hard coding will be removed once we've data from the third party
        //    will be made customisable later
        //  */
        // response ={
        //     "info": "",
        //     "data": [

        //       {
        //         "slug": "myPartner hotel offer",
        //         "url": "https://www.makemytrip.com/promos/mypartner-fortune-22102020.html",
        //         "heading": "A Special Deal Just for You!",
        //         "sub_heading": "A Special Deal Just for You! Get 10%* Lower Rates on Fortune Hotels EXCLUSIVELY on myPartner!",
        //         "validity_text": "31st Dec 2020",
        //         "img_url": "https://assets-gos3.goibibo.com/myPartner_FortuneOfferNew-1603442848.jpg",
        //         "order": 0
        //       },
        //       {
        //         "slug": "myPartner hotel offer",
        //         "url": "https://mypartner.makemytrip.com/hotels/find-hotels-in-Goa/8717279093827200968/8717279093827200968",
        //         "heading": "Goa is NOW OPEN for Tourists, with no restrictions.",
        //         "sub_heading": "Goa is NOW OPEN for Tourists, with no restrictions. Book MySafety-assured stays",
        //         "img_url": "https://assets-gos3.goibibo.com/mp_offer_GOA-1600938519.jpg",
        //         "order": 0
        //       },
        //       {
        //         "slug": "myPartner hotel offer",
        //         "url": "",
        //         "heading": "Head for the HIMALAYAS-Himachal & Uttarakhand NOW OPEN!",
        //         "sub_heading": "Head for the HIMALAYAS-Himachal & Uttarakhand NOW OPEN! Book your stay now",
        //         "img_url": "https://assets-gos3.goibibo.com/mp_offer_Himanchal-1600938543.jpg",
        //         "order": 0
        //       }
        //     ],
        //     "t": 1.756,
        //     "success": true
        //   }

        dispatch(
          updateOffersDataAction((response.success ? response.data : []) as IOffersApi['data']),
        );
        dispatch(toggleLoadingGetOffersAction(false));
      })
      .catch(err => {
        dispatch(toggleLoadingGetOffersAction(false));
      });
    // }
  };
};

export const fetchCamapaignDataThunk = (
  campaignData,
): ThunkAction<void, AppState, {}, AnyAction> => {
  return (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    toggleLoadingCamapaignAction(true);
    const url = prepareCampaignApiRequest(campaignData);
    megatron({
      name: 'campaign api',
      type: 'GET',
      url,
    })
      .then(response => {
        dispatch(toggleLoadingCamapaignAction(false));
        dispatch(
          campaingDataAction((response.success ? response.data : []) as ICampaignData['data']),
        );
        dispatch(
          updateCampaignHeadData({heading: response.heading, subHeading: response.sub_heading}),
        );
      })
      .catch(err => {
        dispatch(toggleLoadingCamapaignAction(false));
      });
  };
};
